import { useState, useEffect, ReactElement, useRef, useCallback, useMemo } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { AxiosResponse } from 'axios'
import {
  ButtonRef,
  Button,
  Form,
  Grid,
  Input,
  Picker,
  Row,
  Span,
  CheckBox,
  RadioGroup,
  Card,
  SelectForm,
  CurrencyInput,
  AutoCompleteInput,
  InputFile
} from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'
import { StatusIcon, MagnifyingGlassIcon, LoadingIcon } from 'components/Icons'
import { useDebounce, useModal, useAuth, useLoading, useTabs } from 'hooks'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import GenericServices from 'services/Generic/Generic'
import {
  ContractNGTServices,
  ContractServices,
  ISaveFileRequest,
  RequestAnexarEvidenciaContrato,
  ResponseContractById
} from 'services/NGT/Contract'
import {
  RecordsSheetServices,
  RecordsSheetGetBlock,
  IGetBloqueioRequest,
  GetBloqueioResponseDTO,
  GetLiberacaoResponseDTO,
  MotivosBloqueioInterface,
  IAlterarBloqueio
} from 'services/NGT/RecordsSheet'
import {
  SupplierRegistrationServices,
  IFornecedor
} from 'services/NGT/SupplierRegistration'
import { UserCsnService } from 'services/Supplier/Users'
import { COLORS, FONTS, SPACING, TYPOGRAPHY, FORMAT } from 'utils'
import * as yup from 'yup'
import { convertBase64 } from 'utils/functions'
import { ITypeUpload } from 'utils/types'
import AttachedFiles from 'pages/NGT/Contracts/components/AddNewContract/components/AttachedFiles'
import { IRedirectData } from '../..'
import { RecordSheetFormTable } from './components'
import { DateTime } from 'services/database/reportsDatabase'

interface FormProps {
  dataTable: IdataTable
  setDataTable: any
  redirectData: IRedirectData
  motivosBloqueio: MotivosBloqueioInterface[]
  newBlock: boolean
}

interface ResponseBloqAndLib {
  contrato: number
  idFolhaRegistro: number
  numeroDocumento: string
}

export interface IdataTable {
  contratoCobradoId: number
  contratoPendenteId: number
  cdContrato: string
  fornecedorId: number
  nomeFornecedor: string
  idBloqueio: number
  idMotivo: number
  motivo: string
  dataBloqueio: string
  dataLiberacao: string
  txDocumento: string
}

const schema = yup.object({
  cdChamadoCervello: yup.string().nullable(),
  cdContrato: yup
    .string()
    .nullable()
    .required('campo obrigatório')
    .typeError('Campo Obrigatório'),
  cpfCnpj: yup.string().nullable(),
  nmFornecedor: yup.string().nullable(),
  txAlerta: yup.string().nullable()
})

const schemaLiberacao = yup.object({
  txObservacao: yup.string().optional().nullable(),
  libFornecedorPagamento: yup.bool()
})

// Ajuste no Schema: Removidas as validações condicionais que exigiam os campos obrigatoriamente
// A validação será feita manualmente no submit para considerar se há folhas selecionadas
const schemaBloqueio = yup.object({
  MotivoId: yup.object().when('BlockFornecedorPagamento', {
    is: true,
    then: (schema) => schema.nullable().notRequired(),
    otherwise: (schema) =>
      schema.shape({
        idMotivoBloqueio: yup
          .string()
          .required('Campo obrigatório')
          .typeError('Campo Obrigatório'),
        txDescricao: yup
          .string()
          .nullable()
          .required('Campo obrigatório')
          .typeError('Campo Obrigatório'),
        txMotivo: yup
          .string()
          .nullable()
          .required('Campo obrigatório')
          .typeError('Campo Obrigatório')
      }).required('Campo Obrigatório')
  }),
  matriculaSolicitante: yup.string().nullable(),
  nomeSolicitante: yup.string().nullable(),
  observacoes: yup.string().nullable(),
  processo: yup.string().nullable(),
  valorRisco: yup.string().nullable()
})

export interface FolhasRegistro {
  idFolhaRegistro: number
  nmCentroPlanta: string
  TxDocumento: number
  dsTipoDocumento: string
  flBloqPagamento: boolean
  dsFormaPagamento: string
  txDescricao: string
  vlLiquido: number
  dtVencimento: string
  cdFolhaRegistroSRV: string
  txBloqueioPagamento: string
}

export interface Bloqueio {
  vlRiscoPrevidenciario: number
  vlRiscoTrabalhista: number
  vlRiscoOutros: number
  vlTotal: number
  nmFornecedor: string
  statusFornecedor: string
  folhasRegistro: FolhasRegistro[]
}

export interface RequestBloqLiberacao {
  CdContrato: string
  FlBuscarTodosContratos: boolean
  IdFornecedor: number
}

export interface IsearchObject {
  cdContrato: string
  fornecedorId: number
  cdCNPJFornecedor: string
  nmFornecedor: string
}

export const RecordSheetForm: React.FC<FormProps> = ({
  redirectData,
  dataTable,
  setDataTable,
  motivosBloqueio,
  newBlock
}) => {
  const { setLoading, setMsgErro } = useLoading()
  const { showModal } = useModal()
  const { usuarioCsn, user } = useAuth()

  const { tabNavigate, selectedTab, handleRemoveTab } = useTabs()
  const [idContratoPendente, setIdContratoPendente] = useState<number>(0)
  const [idFornecedorPendente, setIdFornecedorPendente] = useState<number>(0)
  const [idBloqueioTeste, setIdBloqueioTeste] = useState<number>(0)
  const [checkedLiberadas, setCheckedLiberadas] = useState<any>([])
  const [params, setParams] = useState<IGetBloqueioRequest>()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isOpenLiberacao, setIsOpenLiberacao] = useState<boolean>(false)
  const [checkedBloqueadas, setCheckedBloqueadas] = useState<any>([])
  const [isCheckedLiberadas, setIsCheckedLiberadas] = useState<boolean>(false)
  const [isCheckedBloqueadas, setIsCheckedBloqueadas] = useState<boolean>(false)
  const [contratoExist, setContratoExist] = useState<boolean>(false)
  const [lockLib, setLockLib] = useState<boolean>(true)
  const [loadingEvidencia, setLoadingEvidencia] = useState<boolean>(false)
  const [dataTableBloqueio, setDataTableBloqueio] =
    useState<GetBloqueioResponseDTO>()
  const [dataTableLiberacao, setDataTableLiberacao] =
    useState<GetLiberacaoResponseDTO>()
  const [autoCompleteContract, setAutoCompleteContract] = useState([])

  const [isLoadingContract, setIsLoadingContract] = useState<boolean>(false)

  const [isFromMagnifyingGlass, setIsFromMagnifyingGlass] = useState<boolean>(false)
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false)

  const idFolhasArray = useMemo(() => {
    if (!checkedLiberadas || !Array.isArray(checkedLiberadas)) {
      return []
    }
    return checkedLiberadas.map((folha) => folha?.idFolhaRegistro).filter(id => id !== undefined)
  }, [checkedLiberadas])

  const isLibFornecedorCheckboxDisabled = useMemo(() => {
    return !(dataTableLiberacao?.statusFornecedor !== 'Green') ||
      dataTableBloqueio?.statusFornecedor !== 'Red';
  }, [dataTableLiberacao, dataTableBloqueio]);

  const searchContract = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsLoadingContract(true)
    ContractServices()
      .GetContractByCodigo(event.target.value)
      .then(({ data }) => {
        setAutoCompleteContract(data.entity)
        setIdFornecedorPendente(data.entity.fornecedorId)
        setIdContratoPendente(data.entity.contratoId)
      })

      .finally(() => setIsLoadingContract(false))
  }

  const {
    control,
    watch,
    handleSubmit,
    reset,
    clearErrors,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const formBloqueio = useForm({
    resolver: yupResolver(schemaBloqueio)
  })

  const formLiberacao = useForm({
    resolver: yupResolver(schemaLiberacao)
  })

  const observacao = formLiberacao.watch('txObservacao') ?? ''
  const fornLibParagamento =
    formLiberacao.watch('libFornecedorPagamento') ?? false

  const blockFornecedorPagamento = formBloqueio.watch('BlockFornecedorPagamento') ?? false;

  const bloqueioSelecionado: MotivosBloqueioInterface =
    formBloqueio.watch('MotivoId')
  const bloqueioMatricula = formBloqueio.watch('matriculaSolicitante')
  const bloqueioAnalista = formBloqueio.watch('nomeSolicitante')
  const [flBlockFornecedorPagamento, setFlBlockFornecedorPagamento] =
    useState<boolean>(false)

  const contrato: string = watch('cdContrato')
  const cpfCnpj = watch('cpfCnpj')
  const [bloqTodosContratos, setBloqTodosContratos] = useState<boolean>(false)

  const idBloqueio = dataTable?.idBloqueio || null
  const txDocumento = dataTable?.txDocumento || null
  const cdChamadoCervello = watch('cdChamadoCervello')

  const [arquivosSelecionados, setArquivosSelecionados] = useState<
    ITypeUpload[]
  >([])
  const [, setFileToDelete] = useState<number[]>([])
  const [searchFile, setSearchFile] = useState<string>('')

  useEffect(() => {
    formBloqueio.clearErrors()
  }, [bloqueioSelecionado])

  useEffect(() => {
    if (selectedTab.position === 2) {
      setValue('escolhaContrato', bloqTodosContratos)
      clearErrors('cdContrato')
    }
  }, [bloqTodosContratos])

  const filterTablesInternal = async (data, fromMagnifyingGlass = false) => {
    setLoading('loading')
    setIsDataLoaded(false)
    setIsFromMagnifyingGlass(fromMagnifyingGlass)

    try {
      const response = await ContractServices().GetByCodigo(data.cdContrato)

      setValue('cpfCnpj', response.data?.cnpj.trim())
      setValue('nmFornecedor', response?.data?.nmFornecedor.trim())

      let shouldSearchAllContractsForBloqueio: boolean
      let shouldSearchAllContractsForLiberacao: boolean

      if (fromMagnifyingGlass) {
        shouldSearchAllContractsForBloqueio = false
        shouldSearchAllContractsForLiberacao = true
      } else {
        shouldSearchAllContractsForBloqueio = bloqTodosContratos
        shouldSearchAllContractsForLiberacao = bloqTodosContratos
      }

      const bloqueioParams: IGetBloqueioRequest = {
        ...(shouldSearchAllContractsForBloqueio ? { flBuscarTodosContratos: true } : null),
        cdContrato: data.cdContrato,
        idBloqueio: idBloqueio || null,
        idFornecedor: response.data.fornecedorId,
        isFromMagnifyingGlass: fromMagnifyingGlass
      }

      setParams({
        ...(shouldSearchAllContractsForBloqueio ? { flBuscarTodosContratos: true } : null),
        cdContrato: data.cdContrato,
        idBloqueio: idBloqueio || null,
        isFromMagnifyingGlass: fromMagnifyingGlass,
        ...(shouldSearchAllContractsForBloqueio && {
          idFornecedor: response.data.fornecedorId
        })
      })

      setContratoExist(true)
      setIdContratoPendente(response.data.idContrato)
      setIdFornecedorPendente(response.data.fornecedorId)
      setIdBloqueioTeste(idBloqueio)

      Object.keys(bloqueioParams).forEach((key) => {
        if (
          bloqueioParams[key] === undefined ||
          bloqueioParams[key] === null ||
          bloqueioParams[key] === ''
        ) {
          delete bloqueioParams[key]
        }
      })

      await Promise.all([
        getBloqueio(bloqueioParams),
        getLiberacao(
          data.idBloqueio,
          data.cdContrato,
          response.data.fornecedorId,
          dataTable == null ? null : dataTable.dataLiberacao,
          dataTable == null ? null : dataTable.txDocumento,
          shouldSearchAllContractsForLiberacao,
          fromMagnifyingGlass
        )
      ])

      setIsDataLoaded(true)
      setLoading('idle')

    } catch (error: any) {
      setLoading('idle')
      setIsDataLoaded(false)
      if (error?.response?.status === 404) {
        showModal({
          hideButtonCancel: true,
          message: getErrorMessage(error, 'Dados não encontrados para o filtro informado.'),
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      } else {
        showModal({
          hideButtonCancel: true,
          message: getErrorMessage(error, 'Dados não encontrados para o filtro informado.'),
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      }
    }
  }

  const filterTables = (data) => {
    filterTablesInternal(data, false)
  }

  const getBloqueio = async (data: IGetBloqueioRequest) => {
    const results = []

    try {
      const response = await RecordsSheetGetBlock().GetBloqueio(data)

      setDataTableBloqueio(response.data)
      getFormBloqueio(response.data)
      setValue('cdChamadoCervello', response.data?.cdChamadoCervello)

      if (response.data?.folhasRegistro && Array.isArray(response.data.folhasRegistro)) {
        response.data.folhasRegistro.forEach((element) => {
          const x = results.lastIndexOf(element.idContrato)
          if (x === -1) results.push(element.idContrato)
        })

        await getEvidenciasFR(results)
      } else {
        await getEvidenciasFR([])
      }
    } catch (error: any) {
      if (error?.response?.status === 400) {
        showModal({
          hideButtonCancel: true,
          message: getErrorMessage(error, 'Dados não encontrados para o filtro informado.'),
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      } else {
        showModal({
          hideButtonCancel: true,
          message: getErrorMessage(error, 'Erro interno do servidor.'),
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      }
      throw error
    }
  }

  const getFormBloqueio = (data: GetBloqueioResponseDTO) => {
    setFlBlockFornecedorPagamento(
      data?.statusFornecedor === 'Red' ? true : false
    )

    if (!newBlock) {
      formBloqueio.setValue(
        'MotivoId',
        motivosBloqueio?.find(
          (x) => x.idMotivoBloqueio === data?.motivoBloqueioId
        )
      )

      let observacoes = ''

      if (data?.folhasRegistro && Array.isArray(data.folhasRegistro)) {
        for (let i = 0; i < data.folhasRegistro.length; i++) {
          if (data.folhasRegistro[i]?.motivo != null) {
            observacoes += data.folhasRegistro[i].motivo
            if (i != data.folhasRegistro.length - 1) observacoes += ' /// '
          }
        }
      }

      formBloqueio.setValue('dataBloqueio', data?.dataBloqueio)
      formBloqueio.setValue('matriculaSolicitante', data?.matriculaSolicitante)
      formBloqueio.setValue('nomeSolicitante', data?.nomeSolicitante)
      formBloqueio.setValue('valorRisco', data?.valorRisco || '')
      formBloqueio.setValue('observacoes', observacoes)
      formBloqueio.setValue('processo', data?.processo)
    }
  }

  const getEvidenciasFR = async (contratoPrincipalId: number[] | null) => {
    setLoadingEvidencia(true)

    try {
      if (!contratoPrincipalId || !Array.isArray(contratoPrincipalId) || contratoPrincipalId.length === 0) {
        setArquivosSelecionados([])
        setLoadingEvidencia(false)
        return
      }

      const promises = contratoPrincipalId.map((id) =>
        GenericServices.GetEvidencia(id, 3)
      )
      const responses = await Promise.all(promises)

      const allEvidencias = responses.flatMap(
        (response) => response?.data || []
      )

      setArquivosSelecionados(allEvidencias)
      setLoadingEvidencia(false)
    } catch (err: any) {
      setLoadingEvidencia(false)
      setMsgErro('Não foi possivel carregar evidencias.')
      throw err
    }
  }

  const AlterarBloqueio = (request: IAlterarBloqueio) => {
    try {
      RecordsSheetServices()
        .AlterarBloqueio(request)
        .then((response) => {
          setLoading('idle')
          if (response?.status == 200) {
            showModal({
              hideButtonCancel: true,
              message:
                response?.data?.mensagem || 'Sucesso ao salvar alterações.',
              txtButtonConfirm: 'OK',
              type: response?.data?.sucesso ? 'success' : 'alert'
            })
          } else {
            showModal({
              hideButtonCancel: true,
              message: 'Ocorreu um problema ao alterar o bloqueio!.',
              txtButtonConfirm: 'OK',
              type: 'alert'
            })
          }
        })
        .catch((error) => {
          setLoading('idle')
          const errorMessage = getErrorMessage(error, 'Ocorreu um problema ao tentar realizar o bloqueio.')
          showModal({
            hideButtonCancel: true,
            message: errorMessage,
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        })
    } catch (error) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Ocorreu um problema ao alterar o bloqueio!.',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
    }
  }

  const getLiberacao = async (idBloqueio: number, cdContrato: string, idFornecedor: number, dtLiberacao: DateTime, txNumeroDocumento: string, flBuscarTodosContratos: boolean, isFromMagnifyingGlass: boolean) => {
    try {
      const response = await RecordsSheetGetBlock().GetLiberacao(
        idBloqueio,
        cdContrato,
        idFornecedor,
        dtLiberacao,
        txNumeroDocumento,
        flBuscarTodosContratos,
        isFromMagnifyingGlass
      )

      if (response?.status == 200) {
        setFlBlockFornecedorPagamento(response?.data?.statusFornecedor === 'Green')
        setDataTableLiberacao(response?.data)

        let observacoes = response.data?.observacoes || '';

        if (response.data?.folhasRegistro && Array.isArray(response.data.folhasRegistro)) {
          const observacoesFrs = response.data.folhasRegistro.map(x => x?.motivo || '');

          if (response.data.folhasRegistro.length > 0) {
            observacoes = response.data.folhasRegistro[0]?.motivo || '';
          }

          const observacoesFrsUnicas = Array.from(new Set(observacoesFrs.filter(obs => obs !== '')));
          const observacoesFrsString = observacoesFrsUnicas.join('///');

          formLiberacao.setValue('txObservacao', observacoesFrsString);
        } else {
          formLiberacao.setValue('txObservacao', observacoes);
        }

        formLiberacao.setValue('libFornecedorPagamento', response?.data?.statusFornecedor === 'Green')
      }
    } catch (error: any) {
      if (error?.response?.status === 400) {
        showModal({
          hideButtonCancel: true,
          message: getErrorMessage(error, 'Dados não encontrados para o filtro informado.'),
          txtButtonConfirm: 'OK',
          type: 'alert'
        });
      } else {
        showModal({
          hideButtonCancel: true,
          message: getErrorMessage(error, 'Erro interno do servidor.'),
          txtButtonConfirm: 'OK',
          type: 'error'
        });
      }
      throw error
    }
  };

  const getErrorMessage = (error: any, defaultMessage: string): string => {
    return error?.response?.data ||
      error?.response?.data?.message ||
      error?.message ||
      defaultMessage;
  }

  const handleModalMessage = (resp: any, isLiberado: boolean) => {
    if (
      resp?.data?.errorList?.$values?.length > 0 &&
      resp?.data?.response?.$values?.length > 0
    ) {
      return convertErrorsToReactElement(
        resp?.data?.errorList.$values,
        resp?.data?.response.$values,
        isLiberado
      )
    } else if (resp?.data?.errorList?.$values?.length > 0) {
      return convertErrorsToReactElement(
        resp?.data?.errorList.$values,
        [],
        isLiberado
      )
    } else if (resp?.data?.response?.$values?.length > 0) {
      return convertErrorsToReactElement(
        [],
        resp?.data?.response.$values,
        isLiberado
      )
    } else {
      return resp?.data?.mensagem
    }
  }

  const handleModalType = (resp: any) => {
    if (
      resp?.data?.errorList?.$values?.length > 0 &&
      resp?.data?.response?.$values?.length > 0
    ) {
      return 'alert'
    } else if (resp?.data?.errorList?.$values?.length > 0) {
      return 'alert'
    } else if (resp?.data?.response?.$values?.length > 0) {
      return 'success'
    } else {
      return 'success'
    }
  }

  const selectedUserFiles = arquivosSelecionados?.filter(
    (files: ITypeUpload) => files.base64
  )

  const filesToSave = (tipoDocumentoId: number): ISaveFileRequest[] => {
    return selectedUserFiles?.length > 0
      ? arquivosSelecionados?.map((file: ITypeUpload) => ({
        descricao:
          file.dsExtensaoDoc !== '' && file.dsExtensaoDoc !== null
            ? file.dsExtensaoDoc
            : 'DOCUMENTO CONTRATO',
        file: FORMAT.file(file.base64),
        nomeArquivo: file.dsDocumento,
        nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
        tipoDocumentoId: tipoDocumentoId,
        tipoPendenciaId: 13,
        usuarioId: user.IdUsuario
      }))
      : []
  }

  const handleSubmitLiberacao = (data) => {
    setLoading('loading')

    if (!checkedLiberadas || !Array.isArray(checkedLiberadas) || checkedLiberadas.length === 0) {
      if (!fornLibParagamento) {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Selecione pelo menos uma folha de registro para liberar.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
        return
      }
    }

    const bloqueiosAgrupados = checkedLiberadas.reduce((acc, folha) => {
      if (folha?.idBloqueio) {
        if (!acc[folha.idBloqueio]) {
          acc[folha.idBloqueio] = []
        }
        acc[folha.idBloqueio].push({
          IdFRLiberada: folha.idFolhaRegistro,
          IdBloqueioFR: folha.idBloqueio
        })
      }
      return acc
    }, {})

    let promises = [];

    if (Object.keys(bloqueiosAgrupados).length > 0) {
      promises = Object.keys(bloqueiosAgrupados).map(idBloqueio => {
        const frsDoBloquio = bloqueiosAgrupados[idBloqueio]

        const value = {
          IdBloqueio: parseInt(idBloqueio),
          dataLiberacao: moment(new Date()).toISOString(),
          frsLiberadas: frsDoBloquio,
          idFornecedorPrincipal: idFornecedorPendente,
          idRespLiberacao: usuarioCsn.UsuarioId,
          matricula: usuarioCsn.NmMatricula.trim(),
          txObservacao: data.txObservacao ? data.txObservacao : '',
          cdChamadoCervello: cdChamadoCervello ?? '',
          flLiberarFornecedor: fornLibParagamento,
          listAnexarDocs: filesToSave(3)
        }

        return RecordsSheetServices().LiberarFRS(value)
      })
    }
    else if (fornLibParagamento) {
      const value = {
        IdBloqueio: 0,
        dataLiberacao: moment(new Date()).toISOString(),
        frsLiberadas: [],
        idFornecedorPrincipal: idFornecedorPendente,
        idRespLiberacao: usuarioCsn.UsuarioId,
        matricula: usuarioCsn.NmMatricula.trim(),
        txObservacao: data.txObservacao ? data.txObservacao : '',
        cdChamadoCervello: cdChamadoCervello ?? '',
        flLiberarFornecedor: true,
        listAnexarDocs: filesToSave(3)
      }
      promises.push(RecordsSheetServices().LiberarFRS(value))
    }

    Promise.all(promises)
      .then((responses) => {
        setLoading('idle')
        resetFormLiberacao()

        const allErrors = []
        const allSuccess = []

        responses.forEach((resp, index) => {
          if (resp?.data?.errorList?.$values?.length > 0) {
            allErrors.push(...resp.data.errorList.$values)
          }
          if (resp?.data?.response?.$values?.length > 0) {
            allSuccess.push(...resp.data.response.$values)
          }
        })

        const hasErrors = allErrors.length > 0
        const hasSuccess = allSuccess.length > 0

        let message
        if (hasErrors && hasSuccess) {
          message = convertErrorsToReactElement(allErrors, allSuccess, true)
        } else if (hasErrors) {
          message = convertErrorsToReactElement(allErrors, [], true)
        } else if (hasSuccess) {
          message = convertErrorsToReactElement([], allSuccess, true)
        } else {
          message = 'Liberação processada com sucesso!'
        }

        showModal({
          ...(!(hasErrors && !hasSuccess) && { handleConfirm: () => tabNavigate.goBack() }),
          hideButtonCancel: true,
          message: message,
          txtButtonConfirm: 'OK',
          type: hasErrors && !hasSuccess ? 'alert' : 'success'
        })
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Ocorreu um problema ao tentar realizar a liberação.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      })
  }

  useEffect(() => {
    setLockLib(!lockLib)
  }, [checkedLiberadas])

  const convertErrorsToReactElement = (
    errors: string[],
    sucess: ResponseBloqAndLib[],
    isLiberado: boolean
  ): ReactElement => {
    const sucessList: string[] = sucess?.map((sucessos) => {
      return `Folha de Registro ${isLiberado ? 'Liberada' : 'Bloqueada'
        } no NGT, Numero ${sucessos?.numeroDocumento}`
    })
    return (
      <ul>
        {errors && errors?.map((errorValue: string) => <li style={{ color: 'red' }}><strong>{errorValue}</strong></li>)}
        {sucessList &&
          sucessList?.map((sucessValue: string) => <li>{sucessValue}</li>)}
      </ul>
    )
  }

  const handleSubmitBloquear = (data) => {
    setLoading('loading')

    // Validação para o modo SALVAR (Edição vindo da Lupa)
    if (idBloqueio > 0 && !data?.BlockFornecedorPagamento) {
      let hasError = false;

      // Validação do Motivo
      if (!bloqueioSelecionado || !bloqueioSelecionado.idMotivoBloqueio) {
        formBloqueio.setError('MotivoId', { type: 'manual', message: 'Campo Obrigatório' });
        hasError = true;
      } else {
        const tipoId = bloqueioSelecionado.tipoMotivoBloqueioId;
        const txMotivo = bloqueioSelecionado.txMotivo;

        // Validações condicionais baseadas no tipo do motivo (igual ao cadastro novo)
        if (tipoId !== 1) {
          if (!data.matriculaSolicitante) {
            formBloqueio.setError('matriculaSolicitante', { type: 'manual', message: 'Campo Obrigatório' });
            hasError = true;
          }
          if (!data.nomeSolicitante) {
            formBloqueio.setError('nomeSolicitante', { type: 'manual', message: 'Campo Obrigatório' });
            hasError = true;
          }
          // Validação: Valor maior que 1
          const valorRiscoNum = parseFloat(data?.valorRisco);
          if (!data.valorRisco || isNaN(valorRiscoNum) || valorRiscoNum <= 1) {
            formBloqueio.setError('valorRisco', { type: 'manual', message: 'Campo Obrigatório. Valor deve ser maior que 1.' });
            hasError = true;
          }
        }

        if (tipoId === 2) {
          if (!data.processo) {
            formBloqueio.setError('processo', { type: 'manual', message: 'Campo Obrigatório' });
            hasError = true;
          }
        }

        if (txMotivo !== 'Previdenciário e Trabalhista') {
          if (!data.observacoes) {
            formBloqueio.setError('observacoes', { type: 'manual', message: 'Campo Obrigatório' });
            hasError = true;
          }
        }
      }

      if (hasError) {
        setLoading('idle');
        showModal({
          hideButtonCancel: true,
          message: 'Preencha os campos obrigatórios corretamente.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        });
        return;
      }

      // Se passou na validação, monta a requisição e chama a API
      const req = {
        idBloqueio: idBloqueio,
        txObservacao: formBloqueio.getValues('observacoes') || null,
        processo: data.processo || '',
        valorRisco: parseFloat(data?.valorRisco) || 0,
        idMotivo: parseInt(data?.MotivoId?.idMotivoBloqueio),
        matriculaSolicitante: data?.matriculaSolicitante || '',
        nmSolicitante: data?.nomeSolicitante || '',
        idUsuario: user.IdUsuario,
        cdChamadoCervello: cdChamadoCervello ?? '',
        listAnexarDocs: filesToSave(3),
        idFornecedorPrincipal: idFornecedorPendente
      } as IAlterarBloqueio

      AlterarBloqueio(req)
      // Removido o setLoading('idle') daqui para ser gerenciado dentro de AlterarBloqueio
      return
    }

    // Validação manual condicional: Só exige campos extras se houver folhas selecionadas (MODO NOVO BLOQUEIO)
    if (checkedBloqueadas.length > 0 && bloqueioSelecionado) {
      let hasError = false;
      const tipoId = bloqueioSelecionado.tipoMotivoBloqueioId;
      const txMotivo = bloqueioSelecionado.txMotivo;

      // Validação para motivos que não sejam tipo 1 (ex: Judicial)
      if (tipoId !== 1) {
        if (!data.matriculaSolicitante) {
          formBloqueio.setError('matriculaSolicitante', { type: 'manual', message: 'Campo Obrigatório' });
          hasError = true;
        }
        if (!data.nomeSolicitante) {
          formBloqueio.setError('nomeSolicitante', { type: 'manual', message: 'Campo Obrigatório' });
          hasError = true;
        }
        if (!data.valorRisco) {
          formBloqueio.setError('valorRisco', { type: 'manual', message: 'Campo Obrigatório' });
          hasError = true;
        }
      }

      // Validação para motivo tipo 2
      if (tipoId === 2) {
        if (!data.processo) {
          formBloqueio.setError('processo', { type: 'manual', message: 'Campo Obrigatório' });
          hasError = true;
        }
      }

      // Validação de observações
      if (txMotivo !== 'Previdenciário e Trabalhista') {
        if (!data.observacoes) {
          formBloqueio.setError('observacoes', { type: 'manual', message: 'Campo Obrigatório' });
          hasError = true;
        }
      }

      if (hasError) {
        setLoading('idle');
        showModal({
          hideButtonCancel: true,
          message: 'Preencha os campos obrigatórios para bloquear as folhas selecionadas.',
          txtButtonConfirm: 'OK',
          type: 'alert'
        });
        return;
      }
    }

    if (idBloqueio > 0 && !data?.BlockFornecedorPagamento) {
      const req = {
        idBloqueio: idBloqueio,
        txObservacao: formBloqueio.getValues('observacoes') || null,
        processo: data.processo || '',
        valorRisco: parseFloat(data?.valorRisco) || 0,
        idMotivo: parseInt(data?.MotivoId?.idMotivoBloqueio),
        matriculaSolicitante: data?.matriculaSolicitante || '',
        nmSolicitante: data?.nomeSolicitante || '',
        idUsuario: user.IdUsuario,
        cdChamadoCervello: cdChamadoCervello ?? '',
        listAnexarDocs: filesToSave(3),
        idFornecedorPrincipal: idFornecedorPendente
      } as IAlterarBloqueio

      AlterarBloqueio(req)
      setLoading('idle')
      return
    }

    const contratosAgrupados = checkedBloqueadas.reduce((acc, folha) => {
      if (!acc[folha.idContrato]) {
        acc[folha.idContrato] = []
      }
      acc[folha.idContrato].push({
        idContratoCobrado: folha.idContrato,
        idContratoPendente: idContratoPendente,
        idFolhaRegistro: folha.idFolhaRegistro
      })
      return acc
    }, {})

    if (Object.keys(contratosAgrupados).length === 0) {
      const obj = {
        analistaRespBloq: user?.NmUsuario,
        bloqFornPagamento: data?.BlockFornecedorPagamento || false,
        dataBloqueio: moment(data?.dataBloqueio).toISOString(),
        folhasDeRegistros: [],
        idContratoPrincipal: idContratoPendente,
        idFornecedorPrincipal: idFornecedorPendente,
        idMotivo: data?.MotivoId?.idMotivoBloqueio,
        matricula: usuarioCsn?.NmMatricula.trim(),
        matriculaSolicitante: data?.matriculaSolicitante || '',
        nmSolicitante: data?.nomeSolicitante || '',
        observacao: formBloqueio.getValues('observacoes') || null,
        processo: data.processo || '',
        valorRisco: parseFloat(data?.valorRisco) || 0,
        vlRiscoOutros: dataTableBloqueio?.vlRiscoOutros || 0,
        vlRiscoPrevidenciario: dataTableBloqueio?.vlRiscoPrevidenciario || 0,
        vlRiscoTrabalhista: dataTableBloqueio?.vlRiscoTrabalhista || 0,
        vlTotal: dataTableBloqueio?.vlTotal || 0,
        cdChamadoCervello: cdChamadoCervello ?? '',
        listAnexarDocs: filesToSave(3)
      }

      RecordsSheetServices()
        .BloquearFRS(obj)
        .then((resp) => {
          setLoading('idle')
          resetFormBloqueio()
          if (resp.status === 200) {
            showModal({
              handleConfirm: () => {
                if (
                  resp?.data?.errorList?.$values?.length > 0 &&
                  resp?.data?.response?.$values?.length === 0
                ) {
                  clickPesquisarButton()
                } else {
                  tabNavigate.goBack()
                }
              },
              hideButtonCancel: true,
              message: handleModalMessage(resp, false),
              txtButtonConfirm: 'OK',
              type: handleModalType(resp)
            })
          }
        })
        .catch((err) => {
          setLoading('idle')
          const errorMessage = getErrorMessage(err, 'Ocorreu um problema ao tentar realizar o bloqueio.')
          showModal({
            hideButtonCancel: true,
            handleConfirm: () => {
              resetFormBloqueio()
              clickPesquisarButton()
            },
            message: errorMessage,
            txtButtonConfirm: 'OK',
            type: 'alert'
          })
        })
      return
    }

    const promises = Object.keys(contratosAgrupados).map(idContrato => {
      const folhasDoContrato = contratosAgrupados[idContrato]

      const obj = {
        analistaRespBloq: user?.NmUsuario,
        bloqFornPagamento: data?.BlockFornecedorPagamento || false,
        dataBloqueio: moment(data?.dataBloqueio).toISOString(),
        folhasDeRegistros: folhasDoContrato,
        idContratoPrincipal: idContratoPendente,
        idFornecedorPrincipal: idFornecedorPendente,
        idMotivo: data?.MotivoId?.idMotivoBloqueio,
        matricula: usuarioCsn?.NmMatricula.trim(),
        matriculaSolicitante: data?.matriculaSolicitante || '',
        nmSolicitante: data?.nomeSolicitante || '',
        observacao: formBloqueio.getValues('observacoes') || null,
        processo: data.processo || '',
        valorRisco: parseFloat(data?.valorRisco) || 0,
        vlRiscoOutros: dataTableBloqueio?.vlRiscoOutros || 0,
        vlRiscoPrevidenciario: dataTableBloqueio?.vlRiscoPrevidenciario || 0,
        vlRiscoTrabalhista: dataTableBloqueio?.vlRiscoTrabalhista || 0,
        vlTotal: dataTableBloqueio?.vlTotal || 0,
        cdChamadoCervello: cdChamadoCervello ?? '',
        listAnexarDocs: filesToSave(3)
      }

      return RecordsSheetServices().BloquearFRS(obj)
    })

    Promise.all(promises)
      .then((responses) => {
        setLoading('idle')
        resetFormBloqueio()

        const allErrors = []
        const allSuccess = []

        responses.forEach((resp, index) => {
          if (resp?.data?.errorList?.$values?.length > 0) {
            allErrors.push(...resp.data.errorList.$values)
          }
          if (resp?.data?.response?.$values?.length > 0) {
            allSuccess.push(...resp.data.response.$values)
          }
        })

        const hasErrors = allErrors.length > 0
        const hasSuccess = allSuccess.length > 0

        let message
        if (hasErrors && hasSuccess) {
          message = convertErrorsToReactElement(allErrors, allSuccess, false)
        } else if (hasErrors) {
          message = convertErrorsToReactElement(allErrors, [], false)
        } else if (hasSuccess) {
          message = convertErrorsToReactElement([], allSuccess, false)
        } else {
          message = 'Bloqueio processado com sucesso!'
        }

        showModal({
          handleConfirm: () => {
            if (hasErrors && !hasSuccess) {
              clickPesquisarButton()
            } else {
              tabNavigate.goBack()
            }
          },
          hideButtonCancel: true,
          message: message,
          txtButtonConfirm: 'OK',
          type: hasErrors && !hasSuccess ? 'alert' : 'success'
        })
      })
      .catch((error) => {
        console.error("ERRO DA API: ", error)
        setLoading('idle')
        const errorMessage = getErrorMessage(error, 'Ocorreu um problema ao tentar realizar o bloqueio.')
        showModal({
          hideButtonCancel: true,
          handleConfirm: () => {
            resetFormBloqueio()
            clickPesquisarButton()
          },
          message: errorMessage,
          txtButtonConfirm: 'OK',
          type: 'alert'
        })
      })
  }

  const resetFilter = () => {
    reset({
      cdChamadoCervello: '',
      cdContrato: '',
      cpfCnpj: '',
      nmFornecedor: ''
    })
    setBloqTodosContratos(false)
    setValue('escolhaContrato', false)
  }

  const resetFormLiberacao = () => {
    formLiberacao.reset({
      txObservacao: '',
      libFornecedorPagamento: false
    })
    setCheckedLiberadas([])
  }

  const resetFormBloqueio = () => {
    const currentBlockValue = formBloqueio.getValues('BlockFornecedorPagamento');

    formBloqueio.reset({
      MotivoId: '' as any,
      matriculaSolicitante: '',
      nomeSolicitante: '',
      observacoes: '',
      processo: '',
      valorRisco: '',
      BlockFornecedorPagamento: currentBlockValue
    })

    setCheckedBloqueadas([])
  }

  const getSupplier = () => {
    if (dataTable || redirectData.idFornecedor > 0) {
      setLoading('loading')

      SupplierRegistrationServices()
        .get(dataTable?.fornecedorId || redirectData?.idFornecedor)
        .then(({ data }) => {
          if (dataTable || redirectData.idFornecedor > 0) {
            handleDataTable(data)
          }
        })
        .catch(() => {
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message:
              'Não foi possível obter dados do Fornecedor, tente novamente!',
            txtButtonConfirm: 'OK',
            type: 'error'
          })
        })
    }
    setLoading('idle')
  }

  const handleDataTable = (data: IFornecedor) => {
    if (redirectData.idFornecedor > 0) {
      setValue('nmFornecedor', data?.nmFornecedor)
      setValue('cdContrato', redirectData?.cdContrato)
      setValue('cpfCnpj', data?.cdDocto)
      filterTablesInternal({
        CdChamadoCervello: null,
        IdContrato: redirectData?.cdContrato
      }, true)
    } else {
      setValue('nmFornecedor', dataTable?.nomeFornecedor)
      setValue('cdContrato', dataTable?.cdContrato)
      setValue('cpfCnpj', data?.cdDocto)

      filterTablesInternal({
        CdChamadoCervello: null,
        cdContrato: dataTable.cdContrato
      }, true)
    }
  }

  const [analistas, setAnalistas] = useState<
    {
      label: string
      value: any
    }[]
  >([{ label: '', value: {} }])

  const [matriculas, setMatriculas] = useState<
    {
      label: string
      value: any
    }[]
  >([{ label: '', value: {} }])

  const handleSelectedValue = (value) => {
    formBloqueio.setValue('matriculaSolicitante', value.nmMatricula)
    formBloqueio.setValue('nomeSolicitante', value.usuario?.nmUsuario)
    formBloqueio.clearErrors('matriculaSolicitante')
    formBloqueio.clearErrors('nomeSolicitante')
  }

  const handleSearchAnalista = (event) => {
    setAnalistas([])
    setLoading('loading')

    const pesquisarComLike = String(event.target.value).includes('%')

    if (event.target.value === '') {
      setLoading('idle')
      return
    }

    UserCsnService()
      .getByNome(event.target.value, pesquisarComLike)
      .then((response) => {
        const selectedFieldOptions = response.data.map((analista) => ({
          label: analista.usuario.nmUsuario,
          value: analista
        }))

        setAnalistas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao obter os dados da pesquisa!',
          type: 'error'
        })
      })
  }

  const handleSearchMatricula = (event) => {
    setMatriculas([])
    setLoading('loading')
    if (event.target.value === '') {
      setLoading('idle')
      return
    }
    UserCsnService()
      .getByMatricula(event.target.value, true)
      .then((response) => {
        const selectedFieldOptions = response.data.map((analista) => ({
          label: analista.nmMatricula,
          value: analista
        }))

        setMatriculas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao obter os dados da pesquisa!',
          type: 'error'
        })
      })
  }

  const clickPesquisarButton = () => {
    setTimeout(function () {
      if (buttonRef.current) buttonRef.current.click()
    }, 100)
  }

  const buttonRef = useRef(null)

  useEffect(() => {
    if (selectedTab.position === 3) {
      getSupplier()
    }

    return () => {
      setDataTable(null)
      handleRemoveTab({ position: 3 })
    }
  }, [])

  useEffect(() => {
    const hasErrorMotivoId = formBloqueio.formState.errors['MotivoId']

    hasErrorMotivoId &&
      formBloqueio.setError('MotivoId', { message: 'Campo Obrigatório' })
  }, [formBloqueio.formState.errors])

  const tabelaLiberacao = selectedTab.position !== 1;

  const verificandoPosicao = useCallback(() => {
    if (tabelaLiberacao) {
      setIsOpenLiberacao(true);
    }
    else setIsOpen(true);
  }, [tabelaLiberacao]);

  useEffect(() => {
    verificandoPosicao();
  }, []);

  const generateInputToken = (length = 10) => {
    let aleatoryString = ''

    const caracteres =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i < length; i++) {
      aleatoryString += caracteres.charAt(
        Math.floor(Math.random() * caracteres?.length)
      )
    }

    return aleatoryString
  }

  const handleFilterFilesTable = () => {
    if (searchFile !== '') {
      return arquivosSelecionados?.filter(
        (file) =>
          file?.dsDocumento?.toLowerCase().includes(searchFile.toLowerCase()) ||
          file?.dsExtensaoDoc?.toLowerCase().includes(searchFile.toLowerCase())
      )
    }

    return arquivosSelecionados
  }

  const handleFileToDelete = async (file: ITypeUpload) => {
    ContractNGTServices().deleteAnexarEvidenciaContrato(file.anexoDocumentoId)
    if (file.anexoDocumentoId) {
      setFileToDelete((prevState) => [...prevState, file.anexoDocumentoId])
    }

    setArquivosSelecionados((prevState) =>
      prevState.filter((evidencia) => evidencia !== file)
    )
  }

  async function handleSaveFiles() {
    const selectedUserFiles = arquivosSelecionados?.filter(
      (files) => files.base64
    )
    if (selectedUserFiles.length <= 0) return Promise.resolve(true)

    const requests: Promise<any>[] = []
    for (let index = 0; index < arquivosSelecionados.length; index++) {
      const file = arquivosSelecionados[index]

      if (file.documentoPaiId) continue

      const attachment = {
        contratoId: idContratoPendente,
        descricao: file.dsExtensaoDoc,
        documentoPaiId: idContratoPendente,
        file: FORMAT.file(file.base64),
        forncedorId: idFornecedorPendente,
        nomeArquivo: file.dsDocumento,
        nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
        tipoDocumentoId: 3,
        tipoPendenciaId: 13,
        usuarioId: user.IdUsuario
      }

      requests.push(ContractNGTServices().anexarEvidenciaContrato(attachment))
    }

    return Promise.all(requests)
      .then(() => {
        const test = []
        test.push(idContratoPendente)
        getEvidenciasFR(test)
      })
      .catch(() => {
        showModal({
          message:
            'Ocorreu um erro inesperado ao salvar a(s) evidência(s), por favor, verifique-as e tente novamente.',
          txtButtonCancel: '',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })

        return false
      })
      .finally(() => setLoading('idle'))
  }

  const handleChangeFile = async (files) => {
    if (files) {
      setLoading('loading')
      for (let i = 0; i < files.length; i++) {
        const fileBase64 = (await convertBase64(files[i])) as string
        const newObj: ITypeUpload = {
          anexoDocumentoId: files[i].anexoDocumentoId,
          base64: FORMAT.file(fileBase64),
          documentoExternoGedId: String(generateInputToken(10)),
          dsDocumento: files[i].name,
          dsExtensaoDoc: files[i].type || 'application/octet-stream',
          filename: files[i].name
        }
        setArquivosSelecionados((prevState) => {
          const updatedState = [...prevState, newObj]

          return updatedState
        })
      }

      setLoading('idle')
    }
  }

  useEffect(() => {
    if (arquivosSelecionados.length > 0) {
      handleSaveFiles()
    }
  }, [arquivosSelecionados])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Form onSubmit={handleSubmit(filterTables)}>
        <Grid
          gridCols="1.75fr 1.75fr 3fr 1.5fr "
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          <AutoCompleteInput
            control={control}
            errors={errors}
            label="Contrato"
            placeholder="Nº"
            valueName="cdContrato"
            optionValue="cdContrato"
            options={autoCompleteContract || []}
            loading={isLoadingContract}
            formValue="cdContrato"
            type="dynamic"
            onChange={() => null}
            onChangeText={useDebounce(searchContract, 600)}
            marginTop={'auto'}
            noFilter
            disabled={
              contrato === dataTable?.cdContrato && selectedTab.position === 2
            }
          />
          <Input
            placeholder="CPF/CNPJ/Cód.Fornecedor"
            control={control}
            errors={errors}
            label="CPF/CNPJ/Cód.Fornecedor"
            formValue="cpfCnpj"
            mask={
              cpfCnpj && cpfCnpj.length > 9
                ? ['###.###.###-##', '##.###.###/####-##']
                : ['#########']
            }
            required
            disabled
          />
          <Input
            placeholder="Nome do fornecedor"
            defaultValue={
              dataTable && selectedTab.position === 2
                ? dataTable.nomeFornecedor
                : null
            }
            control={control}
            errors={errors}
            label="Fornecedor"
            formValue="nmFornecedor"
            required
            disabled
          />

          <Input
            control={control}
            errors={errors}
            label="Nº Chamado Cervello"
            formValue="cdChamadoCervello"
            required
            disabled={dataTable && selectedTab.position === 2 ? true : false}
          />
        </Grid>

        <Grid
          gridCols="1fr 1fr "
          gridGap={`0 ${SPACING.spacing30}`}
          margin={`0 0 ${SPACING.spacing30} 0`}
        >
          <RadioGroup
            row
            errors={errors}
            defaultValue={
              dataTable &&
                selectedTab.position === 2 &&
                dataTable.contratoCobradoId != dataTable.contratoPendenteId
                ? true
                : false
            }
            marginTop={SPACING.spacing20}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setBloqTodosContratos(
                event.target.value === 'true' ? true : false
              )
              clickPesquisarButton()
            }}
            formValue="escolhaContrato"
            disabled={!contratoExist || dataTable ? true : false}
            listOptions={[
              { label: 'Este Contrato', value: false },
              { label: 'Todos os Contratos', value: true }
            ]}
          />
          {!dataTable && (
            <Row justifyContent="flex-end">
              <Button
                variantButton="outlined"
                onClick={() => resetFilter()}
                text="Limpar"
                marginTop={SPACING.spacing20}
              />
              <ButtonRef
                type="submit"
                ref={buttonRef}
                marginLeft={SPACING.spacing20}
                text="Pesquisar"
                endIcon={<MagnifyingGlassIcon />}
                marginTop={SPACING.spacing20}
              />
            </Row>
          )}
        </Grid>
      </Form>

      {selectedTab.position === 1 && (
        <div>
          <SimpleCollapse
            title="BLOQUEIO"
            isOpen={isOpen}
            setIsOpen={() => setIsOpen(!isOpen)}
          >
            <Form
              onSubmit={formBloqueio.handleSubmit(handleSubmitBloquear)}
              marginLeft={SPACING.spacing20}
              marginRight={SPACING.spacing20}
              marginBottom={SPACING.spacing100}
              padding={SPACING.spacing20}
              boxShadow={`0 0 1em ${COLORS.lightGray}`}
            >
              <Grid
                gridCols="1fr 1fr 1fr 1fr 4fr"
                gridGap={`0 ${SPACING.spacing30}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <CurrencyInput
                  disabled
                  value={dataTableBloqueio?.vlRiscoPrevidenciario}
                  label="Risco Previdenciário"
                  placeholder="R$"
                />
                <CurrencyInput
                  value={dataTableBloqueio?.vlRiscoTrabalhista}
                  label="Risco Trabalhista"
                  placeholder="R$"
                  disabled
                />
                <CurrencyInput
                  disabled
                  value={dataTableBloqueio?.vlRiscoOutros}
                  label="Risco Outros"
                  placeholder="R$"
                />
                <CurrencyInput
                  value={dataTableBloqueio?.vlTotal}
                  label="Total"
                  placeholder="R$"
                  disabled
                />
              </Grid>

              <Row alignItems="center">
                <Span
                  text={`${dataTableBloqueio?.nmFornecedor?.toUpperCase() || '------'
                    } - ${dataTableBloqueio
                      ? dataTableBloqueio?.statusFornecedor == 'Green'
                        ? 'LIBERADO'
                        : 'BLOQUEADO'
                      : '------'
                    }`}
                  color={COLORS.black}
                  fontSize={TYPOGRAPHY.bodySize16}
                  fontWeight={FONTS.bold}
                  marginBottom={SPACING.spacing20}
                  marginTop={SPACING.spacing20}
                />
                <StatusIcon
                  colorIcon={
                    dataTableBloqueio && dataTableBloqueio.statusFornecedor
                      ? dataTableBloqueio.statusFornecedor == 'Green'
                        ? COLORS.success
                        : COLORS.error
                      : COLORS.black
                  }
                  marginLeft={SPACING.spacing20}
                />
              </Row>

              <CheckBox
                marginTop={SPACING.spacing10}
                label="Bloquear Fornecedor Para Pagamento"
                formValue="BlockFornecedorPagamento"
                control={formBloqueio.control}
                disabled={
                  dataTableBloqueio?.statusFornecedor !== 'Green'
                }
              />
              <RecordSheetFormTable
                checkedCheckbox={checkedBloqueadas}
                setCheckedCheckbox={setCheckedBloqueadas}
                tableData={dataTableBloqueio?.folhasRegistro}
                setTableDataStatus={setDataTableBloqueio}
                isBlock
                isConsult={idBloqueio > 0}
                tipo="Bloqueio"
              />
              <Grid
                gridCols="2fr 4fr 2fr 4fr 1fr"
                gridGap={`0 ${SPACING.spacing30}`}
                margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
              >
                <Input
                  disabled
                  value={usuarioCsn?.NmMatricula}
                  label="Matrícula"
                  placeholder="Nº"
                />
                <Input
                  disabled
                  value={user?.NmUsuario}
                  label="Nome Usuário"
                  placeholder="Nome do usuário"
                />
                <Picker
                  disabled
                  label="Data do Bloqueio"
                  value={
                    newBlock ? new Date() : dataTableBloqueio?.dataBloqueio
                  }
                  formValue="dataBloqueio"
                />
                {bloqueioSelecionado || newBlock ? (
                  <SelectForm
                    allObject
                    defaultValue={bloqueioSelecionado?.idMotivoBloqueio}
                    listOptions={motivosBloqueio}
                    label="Motivo"
                    placeholder="Selecione"
                    labelMenu="txDescricao"
                    valueMenu="idMotivoBloqueio"
                    errors={formBloqueio.formState.errors}
                    control={formBloqueio.control}
                    formValue="MotivoId"
                    disabled={false}
                  />
                ) : null}
              </Grid>
              {bloqueioSelecionado && bloqueioSelecionado.idMotivoBloqueio && (
                <>
                  <Grid
                    gridCols="2fr 4fr 2fr 4fr 1fr"
                    gridGap={`0 ${SPACING.spacing30}`}
                    margin={`0 0 ${SPACING.spacing30} 0`}
                  >
                    {bloqueioSelecionado &&
                      bloqueioSelecionado?.tipoMotivoBloqueioId !== 1 && (
                        <>
                          <AutoCompleteInput
                            marginTop={SPACING.spacing5}
                            name="matriculaSolicitante"
                            onChangeText={handleSearchMatricula}
                            options={matriculas || []}
                            errors={formBloqueio.formState.errors}
                            noFilter
                            optionValue="label"
                            value={bloqueioMatricula}
                            formValue="matriculaSolicitante"
                            label="Matrícula Analista"
                            onChange={(selectedValue, value) => {
                              handleSelectedValue(value)
                            }}
                            valueName="value"
                            disabled={false}
                          />
                          <AutoCompleteInput
                            marginTop={SPACING.spacing5}
                            name="nomeSolicitante"
                            onChangeText={(e) =>
                              setTimeout(() => {
                                handleSearchAnalista(e)
                              }, 2000)
                            }
                            value={bloqueioAnalista}
                            formValue="nomeSolicitante"
                            options={analistas}
                            errors={formBloqueio.formState.errors}
                            noFilter
                            onChange={(selectedValue, value) => {
                              handleSelectedValue(value)
                            }}
                            optionValue="label"
                            label="Nome Analista"
                            valueName="value"
                            disabled={false}
                          />

                          <CurrencyInput
                            errors={formBloqueio.formState.errors}
                            control={formBloqueio.control}
                            formValue="valorRisco"
                            label="Valor Risco"
                            placeholder="R$"
                            disabled={false}
                          />
                        </>
                      )}
                    {bloqueioSelecionado &&
                      bloqueioSelecionado?.tipoMotivoBloqueioId === 2 && (
                        <Input
                          errors={formBloqueio.formState.errors}
                          control={formBloqueio.control}
                          formValue="processo"
                          label="Processo"
                          placeholder="Nº"
                          disabled={false}
                        />
                      )}
                  </Grid>

                  <Grid
                    gridCols="1fr"
                    gridGap={`0 ${SPACING.spacing30}`}
                    margin={`0 0 ${SPACING.spacing30} 0`}
                  >
                    <Input
                      errors={formBloqueio.formState.errors}
                      control={formBloqueio.control}
                      formValue="observacoes"
                      label="Observações"
                      placeholder="Observações"
                      multiline
                    />
                  </Grid>
                </>
              )}
              <Row justifyContent="flex-end" marginBottom={SPACING.spacing20}>
                <InputFile
                  onChange={(files) => {
                    const twoGigaBytes = 17179869184

                    if (files[0].size >= twoGigaBytes) {
                      showModal({
                        hideButtonCancel: true,
                        message:
                          'O arquivo anexado não pode ter tamanho maior que 2GB',
                        titleModal: 'Atenção',
                        txtButtonConfirm: 'OK',
                        type: 'alert'
                      })
                      return
                    }
                    handleChangeFile(files)
                  }}
                  renderInput={false}
                  required
                />
                <Button
                  text="Limpar"
                  variantButton="text"
                  marginRight={SPACING.spacing20}
                  onClick={() => resetFormBloqueio()}
                  disabled={idBloqueio > 0}
                />
                <Button
                  text="Voltar"
                  variantButton="outlined"
                  marginRight={SPACING.spacing20}
                  onClick={tabNavigate.goBack}
                />
                <Button
                  text={idBloqueio > 0 ? 'Salvar' : 'Bloquear'}
                  type="submit"
                  disabled={
                    (!idBloqueio && checkedBloqueadas.length === 0 && !blockFornecedorPagamento) ||
                    (checkedBloqueadas.length > 0 && !bloqueioSelecionado?.idMotivoBloqueio)
                  }
                />
              </Row>
              {arquivosSelecionados?.length > 0 && (
                <Grid
                  gridCols="12fr"
                  gridGap={`0 ${SPACING.spacing10}`}
                  margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
                >
                  <Row marginTop={SPACING.spacing5}>
                    <Span
                      text={'Evidências Anexadas'}
                      color={COLORS.black}
                      fontSize={'14px'}
                      fontWeight="700"
                    />
                  </Row>

                  <AttachedFiles
                    tableData={handleFilterFilesTable()}
                    handleDeleteFile={handleFileToDelete}
                  />
                </Grid>
              )}
            </Form>
          </SimpleCollapse>
          <SimpleCollapse
            title="LIBERAÇÃO"
            isOpen={isOpenLiberacao}
            setIsOpen={() => setIsOpenLiberacao(!isOpenLiberacao)}
          >
            <Form
              onSubmit={formLiberacao.handleSubmit(handleSubmitLiberacao)}
              marginLeft={SPACING.spacing20}
              marginRight={SPACING.spacing20}
              marginBottom={SPACING.spacing100}
              padding={SPACING.spacing20}
              boxShadow={`0 0 1em ${COLORS.lightGray}`}
            >
              <Row alignItems="center">
                <Span
                  text={`${dataTableBloqueio?.nmFornecedor?.toUpperCase() || '------'
                    } - ${dataTableLiberacao
                      ? dataTableLiberacao.statusFornecedor == 'Green'
                        ? 'LIBERADO'
                        : 'BLOQUEADO'
                      : dataTableBloqueio
                        ? dataTableBloqueio.statusFornecedor == 'Green'
                          ? 'LIBERADO'
                          : 'BLOQUEADO'
                        : '------'
                    }`}
                  color={COLORS.black}
                  fontSize={TYPOGRAPHY.bodySize16}
                  fontWeight={FONTS.bold}
                  marginBottom={SPACING.spacing20}
                  marginTop={SPACING.spacing20}
                />
                <StatusIcon
                  colorIcon={
                    dataTableLiberacao || dataTableBloqueio
                      ? dataTableLiberacao?.statusFornecedor == 'Green' ||
                        dataTableBloqueio?.statusFornecedor == 'Green'
                        ? COLORS.success
                        : COLORS.error
                      : COLORS.black
                  }
                  marginLeft={SPACING.spacing20}
                />
              </Row>

              <CheckBox
                marginTop={SPACING.spacing10}
                label="Liberar Fornecedor Para Pagamento"
                formValue="libFornecedorPagamento"
                control={formLiberacao.control}
                disabled={isLibFornecedorCheckboxDisabled}
                onChange={(e) => {
                  setIsCheckedLiberadas(e.target.checked)
                }}
              />
              <Grid
                gridCols="1fr 1fr 1fr 1fr 4fr"
                gridGap={`0 ${SPACING.spacing30}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <CurrencyInput
                  disabled
                  value={dataTableLiberacao?.vlRiscoPrevidenciario}
                  label="Risco Previdenciário"
                  placeholder="R$"
                />
                <CurrencyInput
                  disabled
                  value={dataTableLiberacao?.vlRiscoTrabalhista}
                  label="Risco Trabalhista"
                  placeholder="R$"
                />
                <CurrencyInput
                  disabled
                  value={dataTableLiberacao?.vlRiscoOutros}
                  label="Risco Outros"
                  placeholder="R$"
                />
                <CurrencyInput
                  disabled
                  value={dataTableLiberacao?.vlTotal}
                  label="Total"
                  placeholder="R$"
                />
              </Grid>

              <RecordSheetFormTable
                checkedCheckbox={checkedLiberadas}
                setCheckedCheckbox={setCheckedLiberadas}
                tableData={dataTableLiberacao?.folhasRegistro}
                setTableDataStatus={setDataTableLiberacao}
                isBlock={false}
                isConsult={
                  Array.isArray(dataTableLiberacao?.folhasRegistro) &&
                    dataTableLiberacao?.folhasRegistro?.filter(
                      (fr) => fr.flBloqPagamento == true
                    ).length > 0
                    ? false
                    : true

                }
                tipo="Liberacao"
              />

              <Grid
                gridCols="2fr 3fr 2fr 3fr"
                gridGap={`0 ${SPACING.spacing30}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <Input
                  disabled
                  defaultValue={usuarioCsn.NmMatricula}
                  value={usuarioCsn.NmMatricula}
                  label="Matrícula"
                  placeholder="Nº"
                />

                <Input
                  disabled
                  defaultValue={user.NmUsuario}
                  value={user.NmUsuario}
                  label="Nome Usuário"
                  placeholder="Nome do usuário"
                />
                <Picker
                  disabled
                  defaultValue={new Date()}
                  label="Data da Liberação"
                />
              </Grid>

              <Grid
                gridCols="1fr"
                gridGap={`0 ${SPACING.spacing30}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <Input
                  control={formLiberacao.control}
                  errors={formLiberacao.formState.errors}
                  formValue="txObservacao"
                  label="Observações"
                  placeholder="Observações"
                  multiline
                />
              </Grid>
              {arquivosSelecionados?.length > 0 && (
                <Grid
                  gridCols="12fr"
                  gridGap={`0 ${SPACING.spacing10}`}
                  margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
                >
                  <Row marginTop={SPACING.spacing5}>
                    <Span
                      text={'Evidências Anexadas'}
                      color={COLORS.black}
                      fontSize={'14px'}
                      fontWeight="700"
                    />
                  </Row>
                  <AttachedFiles
                    tableData={handleFilterFilesTable()}
                    handleDeleteFile={handleFileToDelete}
                  />
                </Grid>
              )}

              <Row justifyContent="flex-end" marginBottom={SPACING.spacing20}>
                <InputFile
                  onChange={(files) => {
                    const twoGigaBytes = 17179869184

                    if (files[0].size >= twoGigaBytes) {
                      showModal({
                        hideButtonCancel: true,
                        message:
                          'O arquivo anexado não pode ter tamanho maior que 2GB',
                        titleModal: 'Atenção',
                        txtButtonConfirm: 'OK',
                        type: 'alert'
                      })
                      return
                    }
                    handleChangeFile(files)
                  }}
                  renderInput={false}
                  required
                />
                <Button
                  text="Limpar"
                  variantButton="text"
                  marginRight={SPACING.spacing20}
                  onClick={() => resetFormLiberacao()}
                  disabled={
                    idFolhasArray.length === 0
                  }
                />
                <Button
                  text="Voltar"
                  variantButton="outlined"
                  marginRight={SPACING.spacing20}
                  onClick={tabNavigate.goBack}
                />

                <Button
                  text="Liberar"
                  type="submit"
                  disabled={idFolhasArray.length === 0 && (!fornLibParagamento || isLibFornecedorCheckboxDisabled)}
                />
              </Row>
            </Form>
          </SimpleCollapse>
        </div>
      )}
      {
        selectedTab.position !== 1 && (
          <>
            <SimpleCollapse
              title="BLOQUEIO"
              isOpen={isOpen}
              setIsOpen={() => setIsOpen(!isOpen)}
            >
              <Form
                onSubmit={formBloqueio.handleSubmit(handleSubmitBloquear)}
                marginLeft={SPACING.spacing20}
                marginRight={SPACING.spacing20}
                marginBottom={SPACING.spacing100}
                padding={SPACING.spacing20}
                boxShadow={`0 0 1em ${COLORS.lightGray}`}
              >
                <Grid
                  gridCols="1fr 1fr 1fr 1fr 4fr"
                  gridGap={`0 ${SPACING.spacing30}`}
                  margin={`0 0 ${SPACING.spacing30} 0`}
                >
                  <CurrencyInput
                    disabled
                    value={dataTableBloqueio?.vlRiscoPrevidenciario}
                    label="Risco Previdenciário"
                    placeholder="R$"
                  />
                  <CurrencyInput
                    value={dataTableBloqueio?.vlRiscoTrabalhista}
                    label="Risco Trabalhista"
                    placeholder="R$"
                    disabled
                  />
                  <CurrencyInput
                    disabled
                    value={dataTableBloqueio?.vlRiscoOutros}
                    label="Risco Outros"
                    placeholder="R$"
                  />
                  <CurrencyInput
                    value={dataTableBloqueio?.vlTotal}
                    label="Total"
                    placeholder="R$"
                    disabled
                  />
                </Grid>

                <Row alignItems="center">
                  <Span
                    text={`${dataTableBloqueio?.nmFornecedor?.toUpperCase() || '------'
                      } - ${dataTableBloqueio
                        ? dataTableBloqueio?.statusFornecedor == 'Green'
                          ? 'LIBERADO'
                          : 'BLOQUEADO'
                        : '------'
                      }`}
                    color={COLORS.black}
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    marginBottom={SPACING.spacing20}
                    marginTop={SPACING.spacing20}
                  />
                  <StatusIcon
                    colorIcon={
                      dataTableBloqueio && dataTableBloqueio.statusFornecedor
                        ? dataTableBloqueio.statusFornecedor == 'Green'
                          ? COLORS.success
                          : COLORS.error
                        : COLORS.black
                    }
                    marginLeft={SPACING.spacing20}
                  />
                </Row>

                <CheckBox
                  marginTop={SPACING.spacing10}
                  label="Bloquear Fornecedor Para Pagamento"
                  formValue="BlockFornecedorPagamento"
                  control={formBloqueio.control}
                  disabled={
                    dataTableLiberacao?.statusFornecedor == 'Red'
                  }
                />
                <RecordSheetFormTable
                  checkedCheckbox={checkedBloqueadas}
                  setCheckedCheckbox={setCheckedBloqueadas}
                  tableData={dataTableBloqueio?.folhasRegistro}
                  setTableDataStatus={setDataTableBloqueio}
                  isBlock
                  isConsult={idBloqueio > 0}
                  tipo="Bloqueio"
                />
                <Grid
                  gridCols="2fr 4fr 2fr 4fr 1fr"
                  gridGap={`0 ${SPACING.spacing30}`}
                  margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
                >
                  <Input
                    disabled
                    value={usuarioCsn?.NmMatricula}
                    label="Matrícula"
                    placeholder="Nº"
                  />
                  <Input
                    disabled
                    value={user?.NmUsuario}
                    label="Nome Usuário"
                    placeholder="Nome do usuário"
                  />
                  <Picker
                    disabled
                    label="Data do Bloqueio"
                    value={
                      newBlock ? new Date() : dataTableBloqueio?.dataBloqueio
                    }
                    formValue="dataBloqueio"
                  />
                  {bloqueioSelecionado || newBlock ? (
                    <SelectForm
                      allObject
                      defaultValue={bloqueioSelecionado?.idMotivoBloqueio}
                      listOptions={motivosBloqueio}
                      label="Motivo"
                      placeholder="Selecione"
                      labelMenu="txDescricao"
                      valueMenu="idMotivoBloqueio"
                      errors={formBloqueio.formState.errors}
                      control={formBloqueio.control}
                      formValue="MotivoId"
                      disabled={false}
                    />
                  ) : null}
                </Grid>
                {bloqueioSelecionado && bloqueioSelecionado.idMotivoBloqueio && (
                  <>
                    <Grid
                      gridCols="2fr 4fr 2fr 4fr 1fr"
                      gridGap={`0 ${SPACING.spacing30}`}
                      margin={`0 0 ${SPACING.spacing30} 0`}
                    >
                      {bloqueioSelecionado &&
                        bloqueioSelecionado?.tipoMotivoBloqueioId !== 1 && (
                          <>
                            <AutoCompleteInput
                              marginTop={SPACING.spacing5}
                              name="matriculaSolicitante"
                              onChangeText={handleSearchMatricula}
                              options={matriculas || []}
                              errors={formBloqueio.formState.errors}
                              noFilter
                              optionValue="label"
                              value={bloqueioMatricula}
                              formValue="matriculaSolicitante"
                              label="Matrícula Analista"
                              onChange={(selectedValue, value) => {
                                handleSelectedValue(value)
                              }}
                              valueName="value"
                              disabled={false}
                            />
                            <AutoCompleteInput
                              marginTop={SPACING.spacing5}
                              name="nomeSolicitante"
                              onChangeText={(e) =>
                                setTimeout(() => {
                                  handleSearchAnalista(e)
                                }, 2000)
                              }
                              value={bloqueioAnalista}
                              formValue="nomeSolicitante"
                              options={analistas}
                              errors={formBloqueio.formState.errors}
                              noFilter
                              onChange={(selectedValue, value) => {
                                handleSelectedValue(value)
                              }}
                              optionValue="label"
                              label="Nome Analista"
                              valueName="value"
                              disabled={false}
                            />

                            <CurrencyInput
                              errors={formBloqueio.formState.errors}
                              control={formBloqueio.control}
                              formValue="valorRisco"
                              label="Valor Risco"
                              placeholder="R$"
                              disabled={false}
                            />
                          </>
                        )}
                      {bloqueioSelecionado &&
                        bloqueioSelecionado?.tipoMotivoBloqueioId === 2 && (
                          <Input
                            errors={formBloqueio.formState.errors}
                            control={formBloqueio.control}
                            formValue="processo"
                            label="Processo"
                            placeholder="Nº"
                            disabled={false}
                          />
                        )}
                    </Grid>

                    <Grid
                      gridCols="1fr"
                      gridGap={`0 ${SPACING.spacing30}`}
                      margin={`0 0 ${SPACING.spacing30} 0`}
                    >
                      <Input
                        errors={formBloqueio.formState.errors}
                        control={formBloqueio.control}
                        formValue="observacoes"
                        label="Observações"
                        placeholder="Observações"
                        multiline
                      />
                    </Grid>
                    {arquivosSelecionados?.length > 0 && (
                      <Grid
                        gridCols="12fr"
                        gridGap={`0 ${SPACING.spacing10}`}
                        margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
                      >
                        <Row marginTop={SPACING.spacing5}>
                          <Span
                            text={'Evidências Anexadas'}
                            color={COLORS.black}
                            fontSize={'14px'}
                            fontWeight="700"
                          />
                        </Row>
                        <AttachedFiles
                          tableData={handleFilterFilesTable()}
                          handleDeleteFile={handleFileToDelete}
                        />
                      </Grid>
                    )}
                  </>
                )}
                <Row justifyContent="flex-end" marginBottom={SPACING.spacing20}>
                  <InputFile
                    onChange={(files) => {
                      const twoGigaBytes = 17179869184

                      if (files[0].size >= twoGigaBytes) {
                        showModal({
                          hideButtonCancel: true,
                          message:
                            'O arquivo anexado não pode ter tamanho maior que 2GB',
                          titleModal: 'Atenção',
                          txtButtonConfirm: 'OK',
                          type: 'alert'
                        })
                        return
                      }
                      handleChangeFile(files)
                    }}
                    renderInput={false}
                    required
                  />
                  <Button
                    text="Limpar"
                    variantButton="text"
                    marginRight={SPACING.spacing20}
                    onClick={() => resetFormBloqueio()}
                    disabled={idBloqueio > 0}
                  />
                  <Button
                    text="Voltar"
                    variantButton="outlined"
                    marginRight={SPACING.spacing20}
                    onClick={tabNavigate.goBack}
                  />
                  <Button
                    text={idBloqueio > 0 ? 'Salvar' : 'Bloquear'}
                    type="submit"
                    disabled={
                      (!idBloqueio && checkedBloqueadas.length === 0 && !blockFornecedorPagamento) ||
                      (checkedBloqueadas.length > 0 && !bloqueioSelecionado?.idMotivoBloqueio)
                    }
                  />
                </Row>
              </Form>
            </SimpleCollapse>
            <SimpleCollapse
              title="LIBERAÇÃO"
              isOpen={isOpenLiberacao}
              setIsOpen={() => setIsOpenLiberacao(!isOpenLiberacao)}
            >
              <Form
                onSubmit={formLiberacao.handleSubmit(handleSubmitLiberacao)}
                marginLeft={SPACING.spacing20}
                marginRight={SPACING.spacing20}
                marginBottom={SPACING.spacing100}
                padding={SPACING.spacing20}
                boxShadow={`0 0 1em ${COLORS.lightGray}`}
              >
                <Row alignItems="center">
                  <Span
                    text={`${dataTableBloqueio?.nmFornecedor?.toUpperCase() || '------'
                      } - ${dataTableLiberacao
                        ? dataTableLiberacao.statusFornecedor == 'Green'
                          ? 'LIBERADO'
                          : 'BLOQUEADO'
                        : dataTableBloqueio
                          ? dataTableBloqueio.statusFornecedor == 'Green'
                            ? 'LIBERADO'
                            : 'BLOQUEADO'
                          : '------'
                      }`}
                    color={COLORS.black}
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    marginBottom={SPACING.spacing20}
                    marginTop={SPACING.spacing20}
                  />
                  <StatusIcon
                    colorIcon={
                      dataTableLiberacao || dataTableBloqueio
                        ? dataTableLiberacao?.statusFornecedor == 'Green' ||
                          dataTableBloqueio?.statusFornecedor == 'Green'
                          ? COLORS.success
                          : COLORS.error
                        : COLORS.black
                    }
                    marginLeft={SPACING.spacing20}
                  />
                </Row>

                <CheckBox
                  marginTop={SPACING.spacing10}
                  label="Liberar Fornecedor Para Pagamento"
                  formValue="libFornecedorPagamento"
                  control={formLiberacao.control}
                  disabled={isLibFornecedorCheckboxDisabled}
                  onChange={(e) => {
                    setIsCheckedLiberadas(e.target.checked)
                  }}
                />
                <Grid
                  gridCols="1fr 1fr 1fr 1fr 4fr"
                  gridGap={`0 ${SPACING.spacing30}`}
                  margin={`0 0 ${SPACING.spacing30} 0`}
                >
                  <CurrencyInput
                    disabled
                    value={dataTableLiberacao?.vlRiscoPrevidenciario}
                    label="Risco Previdenciário"
                    placeholder="R$"
                  />
                  <CurrencyInput
                    disabled
                    value={dataTableLiberacao?.vlRiscoTrabalhista}
                    label="Risco Trabalhista"
                    placeholder="R$"
                  />
                  <CurrencyInput
                    disabled
                    value={dataTableLiberacao?.vlRiscoOutros}
                    label="Risco Outros"
                    placeholder="R$"
                  />
                  <CurrencyInput
                    disabled
                    value={dataTableLiberacao?.vlTotal}
                    label="Total"
                    placeholder="R$"
                  />
                </Grid>

                <RecordSheetFormTable
                  checkedCheckbox={checkedLiberadas}
                  setCheckedCheckbox={setCheckedLiberadas}
                  tableData={dataTableLiberacao?.folhasRegistro}
                  setTableDataStatus={setDataTableLiberacao}
                  isBlock={false}
                  isConsult={
                    dataTableLiberacao?.folhasRegistro.filter(
                      (fr) => fr && fr.flBloqPagamento == true
                    ).length > 0
                      ? false
                      : true
                  }
                  tipo="Liberacao"
                />

                <Grid
                  gridCols="2fr 3fr 2fr 3fr"
                  gridGap={`0 ${SPACING.spacing30}`}
                  margin={`0 0 ${SPACING.spacing30} 0`}
                >
                  <Input
                    disabled
                    defaultValue={usuarioCsn.NmMatricula}
                    value={usuarioCsn.NmMatricula}
                    label="Matrícula"
                    placeholder="Nº"
                  />

                  <Input
                    disabled
                    defaultValue={user.NmUsuario}
                    value={user.NmUsuario}
                    label="Nome Usuário"
                    placeholder="Nome do usuário"
                  />
                  <Picker
                    disabled
                    defaultValue={new Date()}
                    label="Data da Liberação"
                  />
                </Grid>

                <Grid
                  gridCols="1fr"
                  gridGap={`0 ${SPACING.spacing30}`}
                  margin={`0 0 ${SPACING.spacing30} 0`}
                >
                  <Input
                    control={formLiberacao.control}
                    errors={formLiberacao.formState.errors}
                    formValue="txObservacao"
                    label="Observações"
                    placeholder="Observações"
                    multiline
                  />
                </Grid>

                {arquivosSelecionados?.length > 0 && (
                  <Grid
                    gridCols="12fr"
                    gridGap={`0 ${SPACING.spacing10}`}
                    margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
                  >
                    <Row marginTop={SPACING.spacing5}>
                      <Span
                        text={'Evidências Anexadas'}
                        color={COLORS.black}
                        fontSize={'14px'}
                        fontWeight="700"
                      />
                    </Row>
                    <AttachedFiles
                      tableData={handleFilterFilesTable()}
                      handleDeleteFile={handleFileToDelete}
                    />
                  </Grid>
                )}

                <Row justifyContent="flex-end" marginBottom={SPACING.spacing20}>
                  <InputFile
                    onChange={(files) => {
                      const twoGigaBytes = 17179869184

                      if (files[0].size >= twoGigaBytes) {
                        showModal({
                          hideButtonCancel: true,
                          message:
                            'O arquivo anexado não pode ter tamanho maior que 2GB',
                          titleModal: 'Atenção',
                          txtButtonConfirm: 'OK',
                          type: 'alert'
                        })
                        return
                      }
                      handleChangeFile(files)
                    }}
                    renderInput={false}
                    required
                  />
                  <Button
                    text="Limpar"
                    variantButton="text"
                    marginRight={SPACING.spacing20}
                    onClick={() => resetFormLiberacao()}
                    disabled={
                      idFolhasArray.length === 0
                    }
                  />
                  <Button
                    text="Voltar"
                    variantButton="outlined"
                    marginRight={SPACING.spacing20}
                    onClick={tabNavigate.goBack}
                  />

                  <Button
                    text="Liberar"
                    type="submit"
                    disabled={idFolhasArray.length === 0 && (!fornLibParagamento || isLibFornecedorCheckboxDisabled)}
                  />
                </Row>
              </Form>
            </SimpleCollapse>
          </>
        )
      }
      {dataTableLiberacao && (
        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Voltar"
            variantButton="outlined"
            marginRight={SPACING.spacing20}
            onClick={tabNavigate.goBack}
          />
        </Row>
      )}
    </Card>
  )
}